import React, { useMemo } from 'react';
import MapaLeaflet from '../mapa/MapaLeaflet';
import { Kpi, Aviso, km, colorKm, COLOR_ANILLO } from './comun';

// Dónde están los lugares del cliente respecto de la base (solo lo ve el admin).
export default function TabEquipos({ datos: d }) {
    const puntos = useMemo(() => [
        { id: 'base', lat: d.base.lat, lng: d.base.lng, color: '#111827', etiqueta: 'B' },
        ...d.lugares.filter(l => l.lat != null).map(l => ({
            id: `s-${l.sedeId}`, lat: l.lat, lng: l.lng, color: colorKm(l.kmBase), etiqueta: l.equipos > 1 ? String(l.equipos) : undefined,
        })),
    ], [d]);
    const circulos = useMemo(() => [5, 10, 20].map((k, i) => ({ lat: d.base.lat, lng: d.base.lng, km: k / 1.3, color: COLOR_ANILLO[i] })), [d]);
    const maxEq = Math.max(1, ...d.anillos.map(a => a.equipos));

    return (
        <div className="space-y-3">
            <p className="text-caption text-muted">Todos los lugares de {d.cliente.nombre} cargados en la app, con sus equipos instalados (no solo los atendidos en el período).</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                <Kpi titulo="Lugares" valor={d.totalLugares} sub={`${d.totalEquipos} equipos · ${d.equiposPorLugar ?? '—'} por lugar`} />
                <Kpi titulo="Distancia media" valor={d.kmBasePromedio != null ? km(d.kmBasePromedio) : '—'} sub={`Desde ${d.base.nombre}`} />
                <Kpi titulo="Entre vecinos" valor={d.vecinoPromedioKm != null ? km(d.vecinoPromedioKm) : '—'} sub="Del lugar más cercano, en promedio" />
                <Kpi titulo="En el mapa" valor={`${d.ubicados} de ${d.totalLugares}`} sub={d.sinUbicar ? `${d.sinUbicar} sin ubicar todavía` : 'Todos ubicados'} />
            </div>
            {d.sinUbicar > 0 && (
                <Aviso tono="alerta">
                    {d.sinUbicar} lugar(es) todavía no tienen ubicación: el sistema las busca de a una en segundo plano.
                    Si alguna no aparece, corregila tocando el punto en la pantalla Mapa.
                </Aviso>
            )}

            <div className="rounded-2xl overflow-hidden border border-black/[0.07] dark:border-white/[0.07]">
                <MapaLeaflet puntos={puntos} circulos={circulos} ajustarKey={`eq-${d.cliente.id}-${puntos.length}`} className="h-72 md:h-96" />
            </div>
            <p className="text-caption text-muted">Anillos de 5, 10 y 20 km de recorrido (aprox.) desde {d.base.nombre}. El número en el punto es la cantidad de equipos.</p>

            <div className="p-3.5 rounded-2xl bg-card border border-black/[0.07] dark:border-white/[0.07] space-y-2">
                <p className="text-label font-black uppercase tracking-widest text-muted">A qué distancia están</p>
                {d.anillos.map((a, i) => (
                    <div key={i} className="flex items-center gap-2">
                        <span className="w-24 shrink-0 text-caption font-bold text-ink">
                            {a.hastaKm == null ? `Más de ${a.desdeKm} km` : `${a.desdeKm}–${a.hastaKm} km`}
                        </span>
                        <div className="flex-1 h-5 rounded-md bg-panel overflow-hidden">
                            <div className="h-full rounded-md" style={{ width: `${(a.equipos / maxEq) * 100}%`, background: COLOR_ANILLO[i] }} />
                        </div>
                        <span className="w-28 shrink-0 text-right text-caption text-secondary">{a.equipos} eq. · {a.lugares} lug.</span>
                    </div>
                ))}
            </div>

            <div className="p-3.5 rounded-2xl bg-card border border-black/[0.07] dark:border-white/[0.07]">
                <p className="text-label font-black uppercase tracking-widest text-muted mb-2">Por zona</p>
                <div className="divide-y divide-black/[0.06] dark:divide-white/[0.06]">
                    {d.zonas.map(z => (
                        <div key={z.zona} className="flex justify-between py-1.5 text-caption">
                            <span className="font-bold text-ink">{z.zona}</span>
                            <span className="text-secondary">{z.equipos} equipos · {z.lugares} lugar{z.lugares !== 1 ? 'es' : ''}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
